import { scoreTypes } from "../types/score.types";

const initState = {
  score: {
    data: [],
    loading: false
  },
};

const actionHandlers = {
  [scoreTypes.GET_SCORE_LIST_REQUEST]: (state) => ({
    ...state,
    score: {
      ...state.score,
      loading: true
    }
  }),
  [scoreTypes.GET_SCORE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    score: {
      data: action.payload.data,
      loading: false
    }
  }),
  [scoreTypes.GET_SCORE_LIST_FAILED]: (state, action) => ({
    ...state,
    score: {
      data: [],
      loading: false,
      error: action.error
    }
  }),
  [scoreTypes.RESET_SCORE_LIST]: (state, _) => ({
    ...state,
    score: { ...initState.score }
  }),
};

const scoreReducer = (state = initState, action) => {
  const handler = actionHandlers[action.type];
  return handler ? handler(state, action) : state;
};

export default scoreReducer;